import { createAction, props } from '@ngrx/store';

export const FIREBASE_ASSOCIATED_DAY_FIND = createAction('[Firebase Associted Day] Find');
// export const FIREBASE_ASSOCIATED_DAY_FIND_SUCCESS = createAction('[Firebase Associted Day] Find Success', props<{ categoryList: Firebase Associted Day[] }>());
// export const FIREBASE_ASSOCIATED_DAY_FAILED = createAction('[Firebase Associted Day] Failed', props<{ error: string }>());
// export const FIREBASE_ASSOCIATED_DAY_UPDATE_LOADING = createAction('[Firebase Associted Day] Update Loading', props<{ loading: boolean }>());
// export const FIREBASE_ASSOCIATED_DAY_UPDATE_ID = createAction('[Firebase Associted Day] Update Id Loading', props<{ categoryId: string }>());


